import React, { forwardRef } from 'react';
import 'react-quill/dist/quill.snow.css';
import ReactQuill from 'react-quill';

const editorStyle = {
  borderRadius: '8px',
  border: 'none',
  fontFamily: 'Inter, Roboto, Open Sans, Arial, sans-serif',
  fontSize: '1.08rem',
  minHeight: '160px',
  padding: '0',
  background: '#fafbfc',
  transition: 'box-shadow 0.2s'
};

const defaultModules = {
  toolbar: [
    [{ header: [1, 2, false] }],
    [{ font: [] }],
    [{ align: [] }],
    [{ color: [] }, { background: [] }],
    [
      { list: 'ordered' },
      { list: 'bullet' },
      { indent: '-1' },
      { indent: '+1' }
    ],
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    ['link', 'image', 'code-block'],
    ['clean']
  ]
};

const FlexBodyEmail = forwardRef(
  (
    {
      modules = defaultModules,
      setValue,
      defaultValue = '',
      value,
      fieldName,
      ...props
    },
    ref
  ) => {
    return (
      <div style={{ ...editorStyle, margin: '0 0 1rem 0', border: 'none' }}>
        <ReactQuill
          {...props}
          modules={modules}
          name={fieldName}
          defaultValue={defaultValue}
          className="editorText"
          theme="snow"
          value={value}
          onChange={(value) => setValue(fieldName, value)}
          style={{
            minHeight: '120px',
            border: 'none',
            background: 'transparent',
            boxShadow: 'none',
            outline: 'none',
            fontFamily: 'inherit',
            fontSize: '1.08rem'
          }}
          ref={ref}
        />
      </div>
    );
  }
);

FlexBodyEmail.displayName = 'FlexBodyEmail';

export { FlexBodyEmail };
